import * as React from "react";
import { SVGProps } from "react";
const SvgPowerOutage1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      stroke="currentColor"
      strokeWidth={2.5}
      d="M29.783 24.652 18.131 3.24a2.467 2.467 0 0 0-.9-.908 2.447 2.447 0 0 0-3.362.908L2.217 24.65a2.372 2.372 0 0 0 .153 2.263A2.348 2.348 0 0 0 4.348 28h23.304a2.33 2.33 0 0 0 1.978-1.086 2.368 2.368 0 0 0 .153-2.262Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.51 18.201a.492.492 0 0 1-.26-.075.527.527 0 0 1-.188-.206.561.561 0 0 1 .02-.55l4.455-7.188a.386.386 0 0 1 .204-.163.365.365 0 0 1 .256.01.39.39 0 0 1 .193.177c.043.08.058.175.043.266l-.843 5.03h3.1c.094 0 .185.026.265.077.08.052.145.125.188.212a.56.56 0 0 1-.037.557l-5.034 7.482a.383.383 0 0 1-.216.157.365.365 0 0 1-.26-.026.394.394 0 0 1-.184-.196.422.422 0 0 1-.021-.275l1.395-5.289h-3.075Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPowerOutage1;
